import React from "react";
import { ChevronRight } from "lucide-react";
import { PERKS } from "../mock";
import { useSite } from "../context/SiteContext";
import { Icon, CrownIcon, LipsIcon } from "./Icons";

export default function AboutPerks({ onVip, isVip }) {
  const { img } = useSite();
  const about = img("about", "/img/about.jpg");
  return (
    <section className="bg-[#fdfbfb]">
      <div className="max-w-[1024px] mx-auto px-6 lg:px-0 lg:pl-[20px] lg:pr-[31px] pt-[24px] pb-[18px] grid lg:grid-cols-[250px_1fr_372px] gap-8 lg:gap-0">
        <div id="about" className="scroll-mt-24 flex justify-center lg:block">
          <div className="polaroid" data-testid="about-photo">
            {about && <img src={about} alt="Maya, virtual creator from Bangalore" className="w-full h-full object-cover" data-testid="about-img" />}
          </div>
        </div>
        <div className="lg:pl-[38px] lg:pr-6 pt-[10px] fade-up">
          <h2 className="serif text-[30px] text-[#1b1719] flex items-center gap-2">Hey, I’m Maya <LipsIcon className="w-7 h-5" /></h2>
          <p className="mt-4 text-[15px] leading-[1.8] text-[#4a4246]">
            I’m a virtual creator from Bangalore who loves good food, gym, travel, spontaneous plans and interesting conversations. This is my private corner where I share more of my world with you.
          </p>
          <div className="signature mt-5">Maya <span className="sig-heart">♡</span></div>
        </div>
        <div id="vip" className="scroll-mt-24 pt-[6px]">
          <h3 className="text-[25px] font-semibold text-[#1b1719] flex items-center gap-3 ml-[4px]">
            <CrownIcon className="w-7 h-7" /> Maya VIP Perks
          </h3>
          <div className="grid grid-cols-2 gap-x-4 gap-y-[22px] mt-[20px] ml-[4px]">
            {PERKS.map((p) => (
              <div key={p.text} className="perk flex items-center gap-[18px]" data-testid="perk-item">
                <Icon name={p.icon} filled={["heart", "star", "user"].includes(p.icon)} className="w-[26px] h-[26px] text-[#ee3a70] shrink-0" />
                <span className="text-[14.5px] leading-[1.45] text-[#26201f]">{p.text}</span>
              </div>
            ))}
          </div>
          <button onClick={onVip} className="btn-vip-big mt-[30px]" data-testid="join-vip-big">
            {isVip ? "Go to my private space" : "Join Maya VIP – ₹499/month"} <ChevronRight className="w-6 h-6" />
          </button>
        </div>
      </div>
    </section>
  );
}
